/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Streetandhousenumber2Inputs */

const en__field_streetandhousenumber2 = /** @type {(inputs: _Field_Streetandhousenumber2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`street and housenumber`)
};

const de__field_streetandhousenumber2 = /** @type {(inputs: _Field_Streetandhousenumber2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Straße und Hausummer`)
};

/**
* | output |
* | --- |
* | "street and housenumber" |
*
* @param {_Field_Streetandhousenumber2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_streetandhousenumber2 = /** @type {((inputs?: _Field_Streetandhousenumber2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Streetandhousenumber2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_streetandhousenumber2(inputs)
	return de__field_streetandhousenumber2(inputs)
});
export { _field_streetandhousenumber2 as "_field_streetAndHousenumber" }